import React from 'react';

import { Alert, AlertType } from 'design_system_components/alert';

export function PartnerSchedulingAlert() {
  return (
    <Alert
      message={
        <>
          Once done, you&apos;ll get a confirmation email from us and can view
          session details on the <i>My studies</i> page.
        </>
      }
      title="You'll be redirected to UserTesting to schedule your session"
      type={AlertType.INFO}
    />
  );
}
